import React from 'react';
import InventoryMessage from './inventory-message';
import Tooltip from '../../shared/components/tooltip';
import { withValidationConsumer } from '../../context/validation/validation-context';

import '../css/validate-purchase-btn.less';

class PurchaseButtonValidator extends React.Component{

    validateForm = (cb) => {
        const { validationErrMsg, isValid } = this.props;
        if(isValid && !validationErrMsg){
            cb();
        }
        return;
    }

    renderPurchaseButton = () => {
        const { validationErrMsg, isValid, purchaseButton } = this.props;
        const pB = React.cloneElement(
            purchaseButton, {
                variant: {},
                onClick: this.validateForm,
                showSelector: this.props.showSelector || false,
                showSelectorHeader: this.props.showSelectorHeader || false
            }
        )
        return(
                (!isValid && validationErrMsg) ?
                <Tooltip label={ pB }>
                    { validationErrMsg }
                </Tooltip> : pB
        )
    }

    render(){
        const {
            product,
            shippingText,
            className,
            purchaseButton,
            withInventoryMsg=true
        } = this.props;
        if(withInventoryMsg){
            return(
                <div className={`pb-validator${className ? ` ${className}` : ''}`}>
                    <InventoryMessage product={product} defaultText={shippingText}>
                    {
                        ({ shippingMsg, stockMsg, className }) => (
                            <div className='purchase-info'>
                                <span className='stock-msg'>{stockMsg}</span>
                                    { this.renderPurchaseButton() }
                                <span className={`shipping-msg${className}`}>{shippingMsg}</span>
                            </div>
                        )
                    }
                    </InventoryMessage>
                </div>
            );
        }else{
            return(
                <div className={`pb-validator${className ? ` ${className}` : ''}`}>
                    { this.renderPurchaseButton() }
                </div>
            );
        }
    }
}

export default withValidationConsumer(PurchaseButtonValidator);
